module.exports = "/assets/c143fa84dff87236b0b6bbefb3c45ffc.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/BW.png
// module id = 1245
// module chunks = 0